import { Paper, Typography } from '@mui/material';

export const NoCallCard = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        width: 210,
        height: 98,
        p: 1,
        bgcolor: '#F7F7F7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '5px',
        border: '2px solid #F7F7F7',
        outline: '2px solid #F7F7F7',
      }}
    >
      <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#A4A4A4' }} align="center">
        No Active Call
      </Typography>
    </Paper>
  );
}

export default NoCallCard;